<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
   *{
     font-family:Microsoft YaHei;
    padding: 0;
    margin: 0;
  }

#app {
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue